<template>
  <section class="text-xs md:text-header-window">
    <p class="mb-2">This text is copied from <a href="https://siternet.net/" target="_blank" rel="noopener" class="text-purple-600">Siternet</a></p>
    
    <p class="mb-4">Hello,</p>
    
    <p class="mb-4">
      Welcome to Siternet website! We are a professional web design agency established in 2018. Since then, we have been helping the digital world by providing website design and development services for businesses and organizations to significantly improve customer access and communication.
    </p>
    
    <p class="mb-4">
      In 2020, we changed our name and brand to Siternet. With this name change, we have increased our focus on providing better and more up-to-date services i
    </p>
    
    <p class="mt-5">
      Read More: <a href="https://siternet.net/" target="_blank" rel="noopener" class="text-purple-600">Siternet</a>
    </p>
  </section>
</template>

<script setup>
let ProjectName = 'Homeserver';
</script>
